import { apiClient } from '../api';
import type { ApiResponse } from '@/types/auth';
import type { AirtimePricing } from '@/types/airtime';

class AdminAirtimeService {
  listPricing() {
    return apiClient.get<ApiResponse<{ pricing: AirtimePricing[] }>>('/admins/pricing/airtime');
  }

  updatePricing(
    id: number,
    payload: Partial<Pick<AirtimePricing, 'providerDiscount' | 'subscriberDiscount' | 'agentDiscount' | 'isActive'>>,
  ) {
    return apiClient.put<ApiResponse<{ pricing: AirtimePricing }>>(`/admins/pricing/airtime/${id}`, payload);
  }
}

export const adminAirtimeService = new AdminAirtimeService();
